import { useEffect } from 'react';
import { useLoaderData, useLocation } from 'react-router';

import PageViewTrackingEvent from '~/events/PageViewTrackingEvent';

import useEnv from './useEnv';
import useRootData from './useRootData';

export default function usePageViewEvent(pageType: string) {
  const { isBot } = useRootData();
  const { FF_PAGE_VIEW_TRACKING } = useEnv();
  const { loaderDurationMs } = useLoaderData() as { loaderDurationMs: number };
  const location = useLocation();

  useEffect(() => {
    if (!FF_PAGE_VIEW_TRACKING) return;

    new PageViewTrackingEvent({
      isBot,
      loaderDurationMs,
      pageType,
      url: location.pathname + location.search
    }).send();
  }, [isBot, FF_PAGE_VIEW_TRACKING, loaderDurationMs, pageType, location]);
}
